// extracted by mini-css-extract-plugin
export var justifyCenter = "styles-module--justifyCenter--3Zx2H";
export var layoutRow = "styles-module--layoutRow--1phRb";
export var reverse = "styles-module--reverse--2Zaqu";
export var smReverse = "styles-module--smReverse--1OJW3";
export var spaceBetween = "styles-module--spaceBetween--1eVrk";
export var verticallyCentre = "styles-module--verticallyCentre--3Go2d";
export var wrap = "styles-module--wrap--1SeXg";